const Cookie = require('Vendor/js-cookie');

module.exports = CompetitionQuestion;

function CompetitionQuestion() {
	var self = this;

	this.init = function() {
		this.rootElement = $('.js-question-widget');
		
		this.ui = {
			checkButton: this.rootElement.find('.js-check-btn'),
			answerPicker: this.rootElement.find('.js-answer-picker'),
			correctSection: this.rootElement.find('.js-answer-correct'),
			incorrectSection: this.rootElement.find('.js-answer-incorrect'),

			loginSection: $('.js-inline-login'),
			loginButton: $('.js-go-login'),
			signupSection: $('.js-inline-signup'),
			signupButton: $('.js-go-signup'),
		};
		
		this.state = {
			correctAnswer: this.rootElement.data('correctAnswer'),
			possibleAnswers: this.rootElement.data('possibleAnswers'),
			sectionId: this.rootElement.data('sectionId'),
			correct: false,
		};

		this.bindEventHandlers();

		if(this.hasSolved()) {
			this.onCorrectAnswer();
		}
	};

	this.bindEventHandlers = function() {
		this.ui.answerPicker.on('change', this.onSelectAnswer.bind(this));

		// To navigate between log in / sign up sections
		this.ui.loginButton.on('click', this.onClickLogin.bind(this));
		this.ui.signupButton.on('click', this.onClickSignup.bind(this));
	};

	this.onSelectAnswer = function(e) {
		console.log("CompetitionQuestion.onSelectAnswer")
		var selected = $(e.target);
		var correct  = this.isCorrectAnswer(selected.val());

		if(correct) {
			console.log("Correct");
			this.onCorrectAnswer();
		} else {
			console.log("Incorrect");
			this.onIncorrectAnswer();
		}
	};

	this.onClickSignup = function(e) {
		e.preventDefault(); // Don't follow links
		this.ui.loginSection.hide();
		this.ui.signupSection.show();

		// Scroll to the top of the page on mobile viewports, otherwise you start halfway down the form
		if(this.isMobileViewport()) {
			this.scrollToElement($('.competition-question-entry-widget__signup'))
		}
	};

	this.onClickLogin = function(e) {
		e.preventDefault(); // Don't follow links
		this.ui.signupSection.hide();
		this.ui.loginSection.show();

		// Scroll to the top of the page on mobile viewports, otherwise you start halfway down the form
		if(this.isMobileViewport()) {
			this.scrollToElement($('.competition-question-entry-widget__login'));
		}
	};

	/**
	 * Drop a cookie to confirm the user has solved this question.
	 * Yes, this is crap (should be stored persistently on the server), but I'm trying to do this quickly and didn't have
	 * time to create table that contains question answers for individual users...
	 */
	this.recordSolve = function() {
		this.state.correct = true;

		Cookie.set('QUESTION_ENTRY_' + this.state.sectionId, true, { expiry: 0 });
	};

	this.hasSolved = function() {
		var cookieVal = Cookie.get('QUESTION_ENTRY_' + this.state.sectionId);
		return cookieVal === "true";
	};

	this.onCorrectAnswer = function(e) {
		// Record the fact the user solved the question, show the success message and unbind the <select> event handler.
		this.recordSolve();
		this.ui.checkButton.hide();
		this.ui.incorrectSection.hide();
		this.ui.correctSection.show();

		var picker = this.ui.answerPicker;

		picker.off('change');
		picker.prop("disabled",true);

		if(picker.length > 1) {
			picker.filter('[value="' + this.state.correctAnswer + '"]').prop("checked",true);
		}
		else {
			picker.val(this.state.correctAnswer);
		}
	};

	this.onIncorrectAnswer = function(e) {
		this.ui.incorrectSection.show();
	};

	this.isCorrectAnswer = function(answer) {
		console.log("CompetitionQuestion.isCorrectAnswer(" + answer + " vs " + this.state.correctAnswer + ")");
		var possible = this.state.possibleAnswers || [];
		
		if(possible.length){
			answer = answer.replace(',','').toLowerCase().trim();
			var possibleArray = possible.split(",");
			return $.inArray(answer, possibleArray) !== -1;
		}

		return answer == this.state.correctAnswer;
	};

	// Determine if the client has a mobile sized viewport
	this.isMobileViewport = function() {
		if(!window.matchMedia) { // Browser doesn't support this method, we can't determine if it's a mobile device.
			return false;
		}
		return window.matchMedia('(max-width: 767px)').matches
	};

	this.init();
}